import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/cost-management/',
    name: 'Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/'),
  },
  {
    path: '/cost-management/travel-cost/create',
    name: 'Create Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
  {
    path: '/cost-management/travel-cost/:id',
    name: 'Detail Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
  {
    path: '/cost-management/vehicle/create',
    name: 'Create Vehicle Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
  {
    path: '/cost-management/vehicle/:id',
    name: 'Detail Vehicle Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
  {
    path: '/cost-management/other/create',
    name: 'Create Other Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
  {
    path: '/cost-management/other/:id',
    name: 'Detail Other Cost Management',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll([
          'financial-record:create',
          'financial-record:read',
          'financial-record:update',
          'financial-record:delete',
        ])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/cost-management/fleet-task-cost'),
  },
]
